module.exports = __webpack_public_path__ + "media/images/iconEdit__inFrontOfAccent--dark-fab63847e5b47d56b4c3e0af8a95e81e.png";